<div *ngIf="createAccountSuccess">
    <app-sign-in
        [$myMessage]="myMessage"
        [$email]
    >
    </app-sign-in>
</div>
<form
    *ngIf="!createAccountSuccess"
    [formGroup]="createAccountForm"
    (ngSubmit)="onSubmit(createAccountForm.value); submitted=true;"
>
    <h1 class="page-title">Create Account</h1>
    <div *ngIf="myMessage && myMessage !== '' && createAccountSuccess==false">
        <strong>{{myMessage}}</strong>
        <br>
        <br>
    </div>
    <div class="field ">
        <div class="field__label-input-wrap">
            <label
                for="Email"
                class="label"
            >
                Email
            </label>
            <input
                style="max-width: 320px;"
                class="input"
                [class.input--invalid]="formErrors.email"
                formControlName="email"
                id="email"
                name="email"
                type="email"
                required
                maxlength="100"
            >
            <div
                *ngIf="formErrors.email"
                class="error-message field__error-message"
            >
                {{ formErrors.email }}
            </div>
        </div>
    </div>

    <div class="field  ">
        <div class="field__label-input-wrap">
            <label
                for
                class="label"
            >
                Social Security Number (SSN)
            </label>
            <input
                class="input"
                [class.input--invalid]="formErrors.ssn"
                formControlName="ssn"
                id="ssn"
                name="ssn"
                required
                mask="000-00-0000"
                placeholder="XXX-XX-XXXX"
            >
            <div
                *ngIf="formErrors.ssn"
                class="error-message field__error-message"
            >
                {{ formErrors.ssn }}
            </div>
        </div>
    </div>

    <div class="field  field--has-help-text">
        <div class="field__label-input-wrap">
            <label
                for
                class="label"
            >
                Zip&#x2F;Postal Code
            </label>
            <input
                class="input"
                [class.input--invalid]="formErrors.zipCode"
                formControlName="zipCode"
                id="zipCode"
                name="zipCode"
                required
                [mask]="'00000'"
            >
            <div
                *ngIf="formErrors.zipCode"
                class="error-message field__error-message"
            >
                {{ formErrors.zipCode }}
            </div>
        </div>
        <!-- <p class="help-text field__help-text">If you do not have an address in the  United States, enter 00000 for your Zip&#x2F;Postal Code.</p> -->
    </div>

    <re-captcha
        #captchaElem
        [siteKey]="siteKey"
        (resolved)="handleSuccess($event)"
        [size]="size"
        [hl]="lang"
        [theme]="theme"
        [type]="type"
        formControlName="recaptcha"
    >
    </re-captcha>

    <div class="form-actions">
        <input
            ng-disabled="submitted"
            class="button form-actions__item"
            name="submitButton"
            type="submit"
            value="Sign Up"
        >
        <div class="form-actions__item form-actions__item--full">
            <div>Already have an account?</div>
            <a
                routerLink="auth"
                class="form-actions__item"
            >
                Sign In
            </a>
        </div>
        <a
            routerLink="../forgot-password"
            class="form-actions__item form-actions__item--full"
        >
            Forgot Password?
        </a>
    </div>
    <div
        *ngIf="createAccountError"
        class="error-message field__error-message"
    >
        {{createAccountError}}
    </div>
</form>
